// "This tablet is a wall panel."
//
// ⚠️ PER DEVICE, NOT PER ACCOUNT — and that is the whole point. A wall tablet
// and the owner's phone are usually the SAME login. Storing this on the user
// record would turn every phone signed into that account into a kiosk that
// boots into a button sheet and demands a password to leave. It is a property
// of the hardware screwed to the wall, so it lives in that tablet's own storage
// and nowhere else.
//
// It is deliberately NOT synced and NOT part of the offline cache: a restore on
// a different device must not inherit it.

const KEY = 'sli_kiosk';

/** -> { enabled, locationId, panelId } */
export function loadKiosk() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { enabled: false, locationId: null, panelId: null };
    const k = JSON.parse(raw);
    return {
      enabled: !!k.enabled,
      locationId: k.locationId ?? null,
      panelId: k.panelId ?? null,
    };
  } catch (e) {
    return { enabled: false, locationId: null, panelId: null };
  }
}

export function saveKiosk(next) {
  try {
    localStorage.setItem(KEY, JSON.stringify({
      enabled: !!next.enabled,
      locationId: next.locationId ?? null,
      panelId: next.panelId ?? null,
    }));
  } catch (e) { /* ignore */ }
}

export const isKiosk = () => loadKiosk().enabled;

export function setKiosk(enabled, locationId = null, panelId = null) {
  saveKiosk({ enabled, locationId, panelId });
}

/**
 * Where the app should open.
 *
 * Returns the wall route when this tablet is a panel, otherwise null so the
 * normal routing applies.
 *
 * ⚠️ Only ever redirects the LANDING route. A kiosk that forced /wall on every
 * navigation would make the designer unreachable — you could configure the
 * panel from anywhere except the tablet it runs on.
 */
export function kioskLandingRoute() {
  const k = loadKiosk();
  if (!k.enabled) return null;
  const q = [
    k.locationId != null ? `locationId=${k.locationId}` : '',
    k.panelId != null ? `panelId=${k.panelId}` : '',
  ].filter(Boolean).join('&');
  return q ? `/wall?${q}` : '/wall';
}
